__turbopack_context__.v({
  "container": "TbXlGG_container",
  "description": "TbXlGG_description",
  "searchTypeButtons": "TbXlGG_searchTypeButtons",
  "title": "TbXlGG_title",
});
